import axios from 'axios';

const qs = require('qs');

const getExternalProviderTransactions = async ({ setData }) => {
	try {
    const response = await axios({
      method: "post",
      data: qs.stringify({
        method: "getExternalProviderTransactions",
      }),
      withCredentials: true,
    });

    // console.log('getExternalProviderTransactions', response.data.results);

    setData(response.data.results);
  } catch {
		console.log('Error getting external provider transactions');
		return { error: 'Error getting external provider transactions' };
	}
};

export default getExternalProviderTransactions;
